import type { FaireProductEntity } from "../../entity_types/product";

export const p_fcrhycshue: FaireProductEntity = {
  token: "p_fcrhycshue",
  type: "product",
  name: "Olive Bandana Fringe Vest",
  brandToken: "b_5m4wqw135i",
  brandName: "Panache Apparel Co.",
  imageUrl: "https://cdn.faire.com/fastly/f6ffea9c77f52c5e619f05419a5600d65c07768e658b90c541ae8acf81f89fd7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d470585f01385511705f847b261f89074ff67977e60e6ff63e453477e45de14f.jpeg",
    "https://cdn.faire.com/fastly/0186b14333767b5358f7ed2085a14f076a7e47d3199e89597e0d23cda7b7f401.jpeg",
    "https://cdn.faire.com/fastly/541183318832c466cd968dabb3a50f478d3c30898adce2914d969e0826a90c68.jpeg",
    "https://cdn.faire.com/fastly/91854302dbb534a8ed020be9264a83f1b6531b33d95ff870d8741752f0f3768e.jpeg"
  ],
  priceDollars: 33.95,
  description: "Olive Bandana Fringe Vest featuring an allover black bandana-inspired pattern, designed with an open front, self-tie waist closure, two front pockets, sleeveless silhouette, and long fringe trim along the front and hem. Finished in a soft knit fabric with a relaxed fit for easy western-inspired layering.\n\n39% Acrylic, 31% Polyester, 30% Polyamide\n\nPre-pack 1-2-2-2-1 (XS-XL)\n\nMin. Qty: 8",
  tags: [],
  msrpDollars: 84.88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:05:45.751Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
